import { formatTipoPago } from "./formatTipoPago"
import { splitBySlash } from "./splitBySlash"

const emptyValue = "-"

// el método de pago llega como "efectivo 250.00": el monto que sigue al método se omite
export const removeAmount = (value: string) => value.replace(/[\s$]*\d[\d.,]*\s*$/, "").trim()

export const formatMetodoPago = (value: string) => formatTipoPago(removeAmount(value))

// origen y método de pago llegan como "valor / detalle, valor / detalle": se descarta el detalle
// que va después del "/" y se muestra "Mixto" cuando hay más de uno, igual que en la tabla del reporte
export const formatSplitValue = (raw?: string, formatMain: (value: string) => string = (value) => value) => {
    if (!raw) {
        return emptyValue
    }

    const values = splitBySlash(raw)

    if (values.length > 1) {
        return "Mixto"
    }

    return formatMain(values[0]?.[0] || "").trim() || emptyValue
}
